import 'twin.macro';
import 'styled-components/macro';
import * as React from 'react';

import empty from './images/empty.svg';
import { Placeholder } from './Placeholder';

interface EmptyPlaceholderProps {
  title: string;
  description?: string;
  buttons?: React.ReactNode;
}

export const EmptyPlaceholder = ({ title, description, buttons }: EmptyPlaceholderProps) => {
  return <Placeholder title={title} description={description} illustration={empty} buttons={buttons} />;
};
